import app from "./app_reducer";
import case_one from "./case_one_reducer";

const rootReducer = {
    app,
    case_one,
};

export default rootReducer;
